import {Injectable} from '@angular/core';
import {AuthenticationService} from '../../../shared/services/authentication.service';
import {SettingsService} from '../../../core/settings/settings.service';
import {sessionPermits, sessionProfileDescription} from '../../../shared/models/login';

@Injectable()
export class UserblockService {

  public userBlockVisible: boolean;

  constructor(public authenticationService: AuthenticationService,
              public settings: SettingsService) {
    // initially visible
    this.userBlockVisible = true;
  }

  setCurrentUser() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.settings.setUserSetting('username', currentUser.session.username);
      this.settings.setUserSetting('picture', 'assets/img/sidebar/user-generic.png');
      this.settings.setUserSetting('profile', sessionProfileDescription(currentUser.session));
      this.settings.setUserSetting('permits', sessionPermits(currentUser.session));
    }
  }

  getVisibility() {
    return this.userBlockVisible;
  }

  setVisibility(stat = true) {
    this.userBlockVisible = stat;
  }

  toggleVisibility() {
    this.userBlockVisible = !this.userBlockVisible;
  }

}
